import { concat, map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type EducationLevelSelectInput_query$key } from '@/__generated__/EducationLevelSelectInput_query.graphql'
import {
  SingleSelectInput,
  type SingleSelectInputProps,
  type SingleSelectInputRef,
  type SingleSelectOption
} from '@/components'

export type EducationLevelSelectInputProps = Omit<SingleSelectInputProps, 'options' | 'ref'> & {
  queryRef: EducationLevelSelectInput_query$key | null | undefined
}

export const EducationLevelSelectInput = forwardRef<SingleSelectInputRef, EducationLevelSelectInputProps>(
  ({ queryRef, ...props }, ref) => {
    const queryData = useFragment(
      graphql`
        fragment EducationLevelSelectInput_query on Query {
          educationLevels(orderBy: [SEQUENCE_ASC]) {
            nodes {
              name
              rowId
            }
          }
        }
      `,
      queryRef
    )

    return (
      <SingleSelectInput
        options={useMemo<SingleSelectOption[]>(
          () =>
            concat(
              map(queryData?.educationLevels?.nodes, (educationLevel) => ({
                label: educationLevel!.name,
                value: educationLevel!.rowId
              })),
              [{ label: 'Don’t Show This', value: null }]
            ),
          [queryData?.educationLevels?.nodes]
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

EducationLevelSelectInput.displayName = 'EducationLevelSelectInput'
